/**
 |--------------------------------------------------------------------------
 | FINANCE : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const finance = [
    {
        path: '/finance/sage_payroll/workers_export_paye', component: require('pages/finance/sage/payroll/workers_export.vue').default,
        name: 'sage_export_paye', 
        meta: { requiresAuth: true, title: "PAYE Payroll Export", icon: "fas fa-coins" }
    },
    {
        path: '/finance/sage_payroll/workers_export_gp_payroll', component: require('pages/finance/sage/payroll/workers_export.vue').default,
        name: 'sage_export_genius_payroll_pl',
        meta: { requiresAuth: true, title: "Genius Payroll - Payroll", icon: "fas fa-coins" }
    },
    {
        path: '/finance/sage_payroll/workers_export_gc_payroll', component: require('pages/finance/sage/payroll/workers_export.vue').default,
        name: 'sage_export_genius_contracts_pl',
        meta: { requiresAuth: true, title: "Genius Contracts - Payroll", icon: "fas fa-coins" }
    }, 
    {
        path: '/finance/sage_accounts/workers_export_gp_accounts', component: require('pages/finance/sage/accounts/workers_export.vue').default,
        name: 'sage_export_genius_payroll_acc',
        meta: { requiresAuth: true, title: "Genius Payroll - Accounts", icon: "fas fa-money-check" }
    },
    {
        path: '/finance/sage_accounts/workers_export_gc_accounts', component: require('pages/finance/sage/accounts/workers_export.vue').default,
        name: 'sage_export_genius_contracts_acc',
        meta: { requiresAuth: true, title: "Genius Contracts - Accounts", icon: "fas fa-money-check" }
    },
    {
        path: '/finance/sage_payroll/workers_export_v3_paye_pl', component: require('pages/finance/sage/payroll/workers_export.vue').default,
        name: 'sage_export_v3_paye_pl',
        meta: { requiresAuth: true, title: "Sage Payroll PAYE", icon: "fas fas fa-coins" }
    },
    {
        path: '/finance/sage_payroll/workers_export_v3_contract_pl', component: require('pages/finance/sage/payroll/workers_export.vue').default,
        name: 'sage_export_v3_contract_pl',
        meta: { requiresAuth: true, title: "Sage Payroll Contracts", icon: "fas fas fa-coins" }
    },
    {
        path: '/finance/sage_payroll/workers_export_v3_paye_acc', component: require('pages/finance/sage/payroll/workers_export.vue').default,
        name: 'sage_export_v3_paye_acc',
        meta: { requiresAuth: true, title: "Sage Accounts PAYE", icon: "fas fa-money-check" }
    },
    {
        path: '/finance/sage_payroll/workers_export_v3_contract_acc', component: require('pages/finance/sage/payroll/workers_export.vue').default,
        name: 'sage_export_v3_contract_acc',
        meta: { requiresAuth: true, title: "Sage Accounts Contracts", icon: "fas fa-money-check" }
    },      
    {
        path: '/finance/workers/tax_export', component: require('pages/finance/tax/workers_export.vue').default,
        name: 'tax_workers_export',
        meta: { requiresAuth: true, title: "Tax Workers Export", icon: "fas fa-pound-sign" }
    },
    // {
    //     path: '/finance/cis/statements', component: require('pages/finance/CIS/statements.vue').default,
    //     name: 'cis_statements',
    //     meta: { requiresAuth: true, title: "CIS Statement Export", icon: "fas fa-pound-sign" }
    // },
    {
        path: '/finance/account_number_search', component: require('pages/finance/account_number_search.vue').default,
        name: 'account_number_search',
        meta: { requiresAuth: true, title: "Account Number Search Export", icon: "fas fa-search-dollar" }
    }, {
        path: '/finance/company_pay_groups', component: require('pages/finance/company_pay_groups.vue').default,
        name: 'company_pay_groups',
        meta: { requiresAuth: true, title: "Company Pay Groups", icon: "fas fa-user-tag" }
    }
];
export default finance;
